export default __webpack_public_path__ + "static/media/green-calender.b89e4958.svg";